import { render, staticRenderFns } from "./ProveedorCreate.vue?vue&type=template&id=5fe13bb5&scoped=true&"
import script from "./ProveedorCreate.vue?vue&type=script&lang=js&"
export * from "./ProveedorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe13bb5",
  null
  
)

export default component.exports